import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		base: 'col-span-6 w-full flex flex-col md:grid md:grid-cols-6 gap-y-2 md:gap-x-4 px-2 md:px-4',
		primaryFigure: 'aspect-square lg:aspect-[887/550] rounded-l overflow-hidden col-span-4',
		secondaryFigure: 'aspect-[335/265] md:aspect-[424/550] rounded-l col-span-2 overflow-hidden',
		image: 'w-full h-full object-cover',
	},
	variants: {
		orientation: {
			false: 'flex-col-reverse',
		},
		withText: {
			true: 'mt-3 md:mt-4',
		},
	},
})

export type CardVariants = VariantProps<typeof styles>
